<template>
  <div class="qualityTracingList">
    <div class="content-container">
      <div class="titieMian">
        <div class="title-container">追溯管理</div>
        <div class="select-container">
          <div class="select-container-box">
            <span class="">时间</span>
            <el-date-picker
              class="place"
              size="small"
              v-model="start"
              type="date"
              placeholder="开始日期"
              :clearable="false"
              value-format="yyyy-MM-dd"
              @change="changeTime(0)"
              :picker-options="pickerTimeOptions">
            </el-date-picker>
          </div>
          <div class="select-container-box" style="padding:0 3px">
            <span style="margin-right:0">-</span>
          </div>
          <div class="select-container-box" style="padding:0 1px">
            <el-date-picker
              class="place"
              size="small"
              v-model="end"
              type="date"
              placeholder="结束日期"
              :clearable="false"
              value-format="yyyy-MM-dd"
              @change="changeTime(1)"
              :picker-options="pickerTimeOptions">
            </el-date-picker>
          </div>
        
          <div class="select-container-box">
            <span>输入查询</span>
            <el-input
              placeholder="请输入关键字"
              v-model="keyWord"
              :maxlength="num"
              onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;"
              size="small"
              class="search-input"
              clearable>
            </el-input>
          </div>
          <div class="select-container-box">
            <el-button size="small"  type="info" plain  class="query" @click="search()">查询</el-button>
            <el-button size="small"  type="info" plain @click="add()" class="add" style="background:#FF812D">添加</el-button>
          </div>  
        </div>
      </div>  
      <div class="table-container">
        <el-table
          :data="qualityTracingList.list"
          style="width:100%"
          size="medium"
          @row-dblclick="dataBackFillGoods"
          :default-sort = "{prop: 'date', order: 'descending'}">
          <i slot="empty" style="font-style:normal">该时间段暂无数据</i>
          <el-table-column
            type="index"
            align="center"
            label="序号"
            >
          </el-table-column>
          <el-table-column
            prop="fishBase"
            align="center"
            show-overflow-tooltip
            label="基地"
            >
          </el-table-column>
          <el-table-column
            prop="fishPond"
            align="center"
            label="塘口"
            show-overflow-tooltip
            >
          </el-table-column>
          <el-table-column
            prop="fishBatch"
            align="center"
            label="周期"
            width="120px"
            v-if="false"
            >
          </el-table-column>
          <el-table-column
            prop="productName"
            label="品种"
            align="center"
            show-overflow-tooltip
            >
          </el-table-column>
          <el-table-column
            prop="code"
            label="追溯编码"
            show-overflow-tooltip
            align="center"
            >
            <template slot-scope="scope">
              <span
                class="content-edit"
                style="text-decoration: underline;"
                @click="handleEdit(scope.$index, scope.row)">{{scope.row.code}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="submitter"
            align="center"
            label="提交人"
            >
          </el-table-column>
          <el-table-column
            prop="date"
            :formatter="formatter"
            align="center"
            label="提交时间"
          >
          </el-table-column>
          <el-table-column label="绑定追溯码" align="center">
            <template slot-scope="scope">
              <span
                v-if="scope.row.traceSubordCode === null"
                class="content-edit"
                @click="bindCode(scope.row.code)">绑定追溯码</span>
                <el-tooltip class="item" effect="dark" :content="scope.row.traceSubordCode" placement="top" v-else>
                  <span class="content-edit red">已绑定</span>
                </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <span
                class="content-edit"
                @click="editTraceCode(scope.$index, scope.row)">编辑</span>
              <span
                class="content-del"
                @click="handleDelete(scope.$index, scope.row)">删除</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <page-change :pageInfo="pageInfo"></page-change>
    </div>
    <el-dialog
      title="查看追溯码"
      :visible.sync="dialogVisible"
      width="660px"
      :before-close="handleClose">
      <div class="left">
        <vue-qr id="qrcode" :logoSrc="config.logo" :text="config.value" :size="config.size" :margin="0"></vue-qr>
        <div style="text-align:center;line-height:32px;">
          追溯编码：{{rowCode}}
        </div>
      </div>
      <div class="right">
        <div>
          <el-radio v-model="radio" label="1" @change="changeSize(1)">
            尺寸： 430*430 （15cm）
          </el-radio>
          <el-radio v-model="radio" label="2" @change="changeSize(2)">
          尺寸： 344*344 （12cm）
          </el-radio>
          <el-radio v-model="radio" label="3" @change="changeSize(3)">
            尺寸： 258*258 （8cm）
          </el-radio>
          <el-button type="primary" @click="downloadImg($event)">下载追溯码</el-button>
       </div>
      </div>
    </el-dialog>
  </div>
</template>


<script>
import Vue from "vue";
import PageChange from "../../common/PageChange";
import { mapState, mapActions } from "vuex";
import { modules } from "../../../store";
import baseUrl from "../../../service/base-url";
import VueQr from "vue-qr";
export default {
  name: "qualityTracingList",
  components: {
    PageChange,
    VueQr
  },
  data() {
    return {
      config: {
        // ../../../assets/images/qualityTracing/logo.png
        value: "", //显示的值、跳转的地址
        logo: require("../../../assets/images/qualityTracing/logo.png"), //中间logo的地址
        size: 430
      },
      radio: "1",
      dialogVisible: false,
      num: 20,
      start: "", //开始时间
      end: "", //结束时间
      pickerTimeOptions: {
        // 限制日期
        disabledDate(time) {
          return time.getTime() > Date.now() - 8.64e6;
        }
      },
      rowCode: "",
      keyWord: "", //查找
      pageInfo: {
        pageNumber: 1, // 当前页数
        totalPages: 0, // 总页数
        pageFunc: this.search, // 当前页数需要调用的函数
        pageSize: 10 // 当前页数
      }
    };
  },
  //默认时间
  created() {
    let startTime = localStorage.getItem("tracingStart");
    let endTime = localStorage.getItem("tracingEnd");
    if (startTime) {
      this.start = startTime;
    } else {
      const start = new Date();
      start.setDate(1);
      start.setMonth(0);
      this.start = this.$timeformatDay(start);
    }
    if (endTime) {
      this.end = endTime;
    } else {
      this.end = this.$timeformatDay(new Date());
    }
  },
  computed: {
    ...mapState(modules.qualityTracing, ["qualityTracingList"])
  },
  mounted() {
    this.search();
  },
  methods: {
    ...mapActions(modules.qualityTracing, [
      "getQualityTracingData", //查询数据
      "delQualityTracing" //删除数据
    ]),
    handleClose(done) {
      this.dialogVisible = false;
    },
    //查询
    search(pageNum) {
      let obj = {
        pageIndex: (this.pageInfo.pageNumber = pageNum || 1),
        pageSize: this.pageInfo.pageSize,
        startDate: this.start,
        endDate: this.end,
        queryString: this.keyWord
      };
      this.getQualityTracingData(obj)
        .then(rsp => {
          if (rsp.status === 200) {
            this.pageInfo.totalPages = rsp.data.total;
          }
        })
        .catch(err => {
          console.dir(err);
        });
    },
    //存储选中时间
    changeTime(type) {
      if (type == 0) {
        localStorage.setItem("tracingStart", this.start);
      } else {
        localStorage.setItem("tracingEnd", this.end);
      }
    },
    // 格式化指定列时间
    formatter(row) {
      if (!row.date) {
        return false;
      }
      return this.$timeformatDay(row.date);
    },
    // 绑定追编码
    bindCode(code) {
      this.$router.push({
        name: "bindQualityTracingCode",
        query: {
          code
        }
      });
    },
    // 编辑追溯码
    editTraceCode(index, row) {
      console.log(index, row);
      this.$router.push({
        name: "addQualityTracing",
        query: {
          traceCode: row.code
        }
      });
    },
    add() {
      //添加
      this.$router.push({
        name: "addQualityTracing"
      });
    },
    handleEdit(index, row) {
      // 二维码跳转地址
      this.config.value = `${baseUrl.mobileServer}?c=${row.code}`;
      console.log(122, this.config.value);

      // this.config.value = `http://ylwm.t.nxin.com/qualityTracing?id=${
      //   row.id
      // }&code=${row.code}`;
      // this.config.value = `http://10.70.1.36:8080/qualityTracing?id=${
      //   row.id
      // }&code=${row.code}`;
      this.dialogVisible = true;
      this.rowCode = row.code;
    },
    // 跳转 移动端质量追溯， ip修改为本机ip
    // jump(index, row) {
    //   window.open(
    //     `http://10.70.1.39:8080/qualityTracing?id=${row.id}&code=${row.code}`
    //   );
    // },
    changeSize(index) {
      switch (index) {
        case 1:
          this.config.size = 430;
          break;
        case 2:
          this.config.size = 344;
          break;
        case 3:
          this.config.size = 258;
          break;
        default:
          break;
      }
    },
    //双击进入编辑页面
    dataBackFillGoods(row, event) {
      // window.open(
      //   `http://10.70.1.39:8080/qualityTracing?id=${row.id}&code=${row.code}`
      // );
    },
    // 下载二维码
    downloadImg(e) {
      var oQrcode = document.querySelector("#qrcode img");
      var url = oQrcode.src;
      var a = document.createElement("a");
      var event = new MouseEvent("click");
      // 下载图名字
      a.download = "追溯码:" + this.rowCode;
      //url
      a.href = url;
      //合成函数，执行下载
      a.dispatchEvent(event);
    },
    handleDelete(index, row) {
      let pageIndex = this.pageInfo.pageNumber;
      if (this.pageInfo.totalPages % 10 === 1) {
        pageIndex -= 1;
      }
      this.$confirm("是否删除此记录", "", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          await this.delQualityTracing(row.id);
          this.search(pageIndex);
          this.$message({
            type: "success",
            message: "删除成功!"
          });
        })
        .catch(err => {
          this.$Alert.info({
            content: err.response.data,
            duration: 5000,
            status: "error"
          });
          // this.$message.error(err.response.data);
        });
    }
  }
};
</script>

<style lang="stylus" >
  .qualityTracingList .content-container .titieMian .select-container{
    margin-top:-5px; 
  }
  #canvas{
    width:200px!important;
    height:200px!important;
  }
  .el-radio+.el-radio{
    margin-left:0;
  }
  .el-dialog__body,.el-dialog__header{
      width:660px;
      background:#fff;
    }
  @media screen and (max-width: 1910px) {
    .el-dialog__body,.el-dialog__header{
      width:660px;
      background:#fff;
    }
    .el-icon-close:before{
      position: absolute;
      top:-10px;
      color:#fff;
   }
   .el-dialog{
    position:absolute;
    left:50%;
    top:100px;
    margin-left:-340px;
    
   }
  } 
 .qualityTracingList{
   .el-dialog__header{
     position:relative;
     background:linear-gradient(270deg,rgba(51,137,255,1),rgba(31,156,244,1),rgba(49,170,255,1));
     padding:10px 20px 10px;
     width:660px;
   }
   .el-dialog__headerbtn{
     position: absolute;
      top: 23px;
      right: 35px;
   }
   .el-icon-close:before{
     position: absolute;
     top:-10px;
     color:#fff;
   }
   .el-dialog__title{
      font-size:18px;
      font-family:MicrosoftYaHei;
      font-weight:400;
      color:rgba(255,255,255,1);
   }
    .el-dialog__body{
      display:flex;
      height:350px;
     
    }
    .left{
      width:42%;
      height:300px;
      margin-left:15px;
      margin-top:15px;
      // border:1px solid red;
      img{
        width:100%;
        height:275px;
      }
    }
    .right{
      width:50%;
      height:276px;
      background:#F5F6F7;
      margin-left:26px;
      margin-top:15px;
      >div{
        padding-left:30px;
      }
      
      .el-radio{
        display: flex;
        align-items: center;
        margin-bottom:20px;
        font-size:8px;
        font-family:MicrosoftYaHei;
        font-weight:400;
        color:rgba(102,102,102,1);
        line-height:25px;
      }
      .el-radio:first-child{
        margin-top:32px;
      }
      .el-radio__label{
        
        font-size:16px;
        font-family:MicrosoftYaHei;
        font-weight:400;
        color:rgba(102,102,102,1);
      }
      
      .el-button--primary{
        width:210px;
        height:40px;
        background:rgba(51,137,255,1);
        border-radius:2px;
        margin-top:25px;
        span{
          font-size:7px;
          font-family:MicrosoftYaHei;
          font-weight:400;
          color:rgba(255,255,255,1);
        }
      }
    }
  }
</style>
